import React, { useState, useEffect } from 'react';
import photo1 from '../foto1.jpg';
import photo2 from '../foto2.jpg';
import photo3 from '../foto3.jpg';
import photo4 from '../foto4.jpg';
import photo5 from '../foto5.jpg';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import Stores from './Stores';
import LoyaltyCard from './LoyaltyCard';
import Shipping from './Shipping';
import Footer from './Footer';

export default function Home() {
  const images = [photo1, photo2, photo3, photo4, photo5];
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [activeSection, setActiveSection] = useState('home');

  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (activeSection === 'home') {
      const interval = setInterval(() => {
        setCurrentImageIndex((prev) => (prev + 1) % images.length);
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [activeSection, images.length]);

  const handleClick = (section) => {
    if ((section === 'loyaltycard' || section === 'shipping') && !user) {
      navigate('/login');
      return;
    }
    setActiveSection(section);
  };

  return (
    <header className="App-header">
      <div className="logo-title-wrapper">
        <img src={require('../logo.PNG')} alt="logo" className="logo-small" />
        <img src={require('../BRUCALIFFO.png')} alt="Brucaliffo" className="title-image" />
      </div>

      <div className="slider-container">
        {activeSection === 'home' && (
          <div className="slider-wrapper">
            <a href={images[currentImageIndex]} target="_blank" rel="noopener noreferrer">
              <img
                src={images[currentImageIndex]}
                alt={`Slide ${currentImageIndex}`}
                className="slider-image"
                style={{ cursor: 'pointer' }}
              />
            </a>
            <div className="slider-dots">
              {images.map((_, index) => (
                <div
                  key={index}
                  className={`slider-dot ${index === currentImageIndex ? 'active' : ''}`}
                  onClick={() => setCurrentImageIndex(index)}
                ></div>
              ))}
            </div>
          </div>
        )}
        {activeSection === 'stores' && <Stores />}
        {activeSection === 'loyaltycard' && <LoyaltyCard />}
        {activeSection === 'shipping' && <Shipping />}
      </div>

      <Footer handleClick={handleClick} />
    </header>
  );
}